module.exports = __webpack_public_path__ + "static/media/em-33.bf5de7fa.png";